var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGear = function SvgGear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.302 10.7h-1.853a5.413 5.413 0 0 1-.689 1.64l1.31 1.31-1.786 1.784-1.309-1.308a5.463 5.463 0 0 1-1.623.671v1.853h-2.55v-1.853a5.463 5.463 0 0 1-1.624-.671L3.87 15.434l-1.802-1.803 1.31-1.309a5.463 5.463 0 0 1-.672-1.623H.852V8.176h1.844a5.536 5.536 0 0 1 .68-1.65L2.067 5.219l1.785-1.785 1.31 1.309a5.504 5.504 0 0 1 1.64-.689V2.2h2.55v1.853c.578.136 1.13.366 1.623.672l1.31-1.31 1.801 1.803-1.309 1.309c.306.501.544 1.054.68 1.649h1.845V10.7Zm-7.225 1.275a2.547 2.547 0 0 0 2.55-2.55 2.547 2.547 0 0 0-2.55-2.55 2.547 2.547 0 0 0-2.55 2.55 2.547 2.547 0 0 0 2.55 2.55Z",
    fill: "#000"
  })));
};

export default SvgGear;